// test2289
(2289 && 0);
